import { render, staticRenderFns } from "./DossiersTable.vue?vue&type=template&id=07108d2e"
import script from "./DossiersTable.vue?vue&type=script&lang=js"
export * from "./DossiersTable.vue?vue&type=script&lang=js"
import style0 from "./DossiersTable.vue?vue&type=style&index=0&id=07108d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports